export default {
  endpoints: {
    stitchBackend: "https://api.production.withstitch.com",
    astraRedirect: "https://onboarding.withstitch.com",
  },
  debug: false,
};
